import type { ReactNode } from 'react';
import { useContext, createContext, useState } from 'react';

type IntersectionRendererContextType = {
  /**
   * Disables/enables intersection observer, useful during programmatic scrolling
   * that could otherwise accidentaly trigger CLS resulting in landing in a wrong
   * scroll position.
   */
  setIntersectionDisabled: (isDisabled: boolean) => void;
  intersectionDisabled: boolean;
};

const intersectionRendererDefaultValue: IntersectionRendererContextType = {
  setIntersectionDisabled: () => void 0,
  intersectionDisabled: false,
};

const IntersectionRendererContext = createContext(
  intersectionRendererDefaultValue
);

type IntersectionRendererProviderProps = {
  children: ReactNode;
};

export const IntersectionRendererProvider = ({
  children,
}: IntersectionRendererProviderProps) => {
  const [intersectionDisabled, setIntersectionDisabled] = useState(
    intersectionRendererDefaultValue.intersectionDisabled
  );

  return (
    <IntersectionRendererContext.Provider
      value={{
        intersectionDisabled,
        setIntersectionDisabled,
      }}
    >
      {children}
    </IntersectionRendererContext.Provider>
  );
};

export function useIntersectionRendererContext() {
  return useContext(IntersectionRendererContext);
}
